// extracted by mini-css-extract-plugin
export default {"actions":"index_actions__aAyH8","description":"index_description__K9nzH","detailLabel":"index_detailLabel__5lasR"};